import React from 'react'

import { Box } from '@mui/material'
import get from 'lodash/get'
import has from 'lodash/has'

import Highlight from 'components/_base/Highlight'

const EMPTY_VALUE_PLACEOLDER = '[EMPTY]'

const formatValue = (value: any) => (value == null || value === '' ? EMPTY_VALUE_PLACEOLDER : String(value))

type DiffProps = {
  field: string
  newData: Record<string, any>
  value?: any
  valueHint?: (...args: any[]) => any
}

const Diff = ({ field, value, newData, valueHint }: DiffProps) => {
  const hasNewValue = has(newData, field)
  const oldValueHint = valueHint?.(value)
  if (hasNewValue) {
    const newValue = get(newData, field)
    const newValueHint = valueHint?.(newValue)

    if (newValue === value) return formatValue(value)

    return (
      <Box sx={{ display: 'flex', gap: '5px' }}>
        <Highlight active color="red">
          {formatValue(value)} {oldValueHint ? `(${oldValueHint})` : ''}
        </Highlight>
        <Highlight active>
          {formatValue(newValue)} {newValueHint ? `(${newValueHint})` : ''}
        </Highlight>
      </Box>
    )
  }
  return (
    <div>
      {formatValue(value)} {oldValueHint ? `(${oldValueHint})` : ''}
    </div>
  )
}

export default Diff
